import { type KeycloakTokenParsed } from "keycloak-js";
import { type BillingInfo, SubscriptionSeat } from "lens-platform-sdk";

export interface SubscriptionSeatWithBillingPeriod extends SubscriptionSeat {
  billingPeriod: string | null;
}

// Plan Name in Recurly, plus "personal" for Personal plan
export enum LicenseType {
  personal = "personal",
  proTrial = "Pro Trial",
  pro = "Pro"
}

export interface LicensedToken extends KeycloakTokenParsed {
  // This is actually Plan Name in Recurly, plus "personal" for Personal plan
  license_type?: LicenseType;
  license_exp?: number;
  license_iat?: number;
  license_trial?: boolean;
  license_features?: string[];
  preferred_username?: string;
}

export type License = {
  type: LicensedToken["license_type"];
  trial: boolean;
  features: LicensedToken["license_features"];
  expiration: Date;
  issuedAt: Date;
};

export interface LicenseContainerProps {
  license?: License;
  onLicenseChange?: () => void;
  onCancelSubscription?: (license: License) => void;
  billingInfoUrl?: string;
  accountUrl?: string;
  billingInfo?: BillingInfo | null;
  subscriptionSeats: SubscriptionSeat[];
  currentSubscriptionSeatWithBillingPeriod?: SubscriptionSeatWithBillingPeriod;
}

export type LicenseContainer = React.FunctionComponent<LicenseContainerProps>;
